import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useField, ErrorMessage } from 'formik';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  errorMessage: {
    fontSize: '0.75rem',
    color: '#f44336',
    marginTop: '3px',
  },
}));

export default (props) => {
  const [field, meta] = useField(props);
  const classes = useStyles();
  return (
    <>
      <TextField {...field} {...props} error={meta.error && meta.touched} />
      {meta.error && meta.touched && (
        <ErrorMessage name={field.name}>
          {(msg) => (
            <Typography className={classes.errorMessage} align='left'>
              {msg}
            </Typography>
          )}
        </ErrorMessage>
      )}
    </>
  );
};
